var Intent = /* @__PURE__ */ ((Intent2) => {
  Intent2["CAPTURE"] = "capture";
  Intent2["AUTHORIZE"] = "authorize";
  Intent2["TOKENIZE"] = "tokenize";
  Intent2["SUBSCRIPTION"] = "subscription";
  return Intent2;
})(Intent || {});
export {
  Intent
};
//# sourceMappingURL=context.js.map
